import React from "react";
import CourseItem from "../CourseItem";
import UnplannedCourseItem from "../CourseItem/unplanned";
import style from "./index.module.scss";
import useRequest from "../../../../../utils/useRequest";
import {
    getNetCourseList,
    getNoWeekTimeCourseList
} from "../../../../../service/course";
import { Spin } from "antd";
import courseImg from "./images/course.png";
import courseImg2 from "./images/course2.png";
import courseImg3 from "./images/course3.png";
import courseImg4 from "./images/course4.png";
import courseImg5 from "./images/course5.png";
import courseImg6 from "./images/course6.png";
import CustomEmpty from "../../../../../components/CourseComponents/CustomEmpty";
import useCurrentDate from "../../../../../utils/useCurrentDate";

function getImgUrl(index: number) {
    const ImgArr = [
        courseImg,
        courseImg2,
        courseImg3,
        courseImg4,
        courseImg5,
        courseImg6
    ];
    const num = index % ImgArr.length;
    return ImgArr[num];
}

function List() {
    const { batchNo } = useCurrentDate();
    const [data, { loading }] = useRequest(() => getNetCourseList(), {}, [
        batchNo
    ]);
    const [dataNoWeekTime, { loading: dataNoWeekTimeLoading }] = useRequest(
        () => getNoWeekTimeCourseList(),
        {},
        [batchNo]
    );

    return (
        <Spin spinning={loading || dataNoWeekTimeLoading}>
            <div className={style.root}>
                {dataNoWeekTime?.map((item, index) => (
                    <CourseItem
                        key={index}
                        className={style.item}
                        data={item}
                        imgUrl={getImgUrl(index)}
                    />
                ))}
                {data?.map((item, index) => (
                    <UnplannedCourseItem
                        key={index}
                        className={style.item}
                        data={item}
                        imgUrl={getImgUrl(
                            (dataNoWeekTime?.length || 0) + index
                        )}
                    />
                ))}
                {dataNoWeekTime?.length === 0 && data?.length === 0 && (
                    <CustomEmpty className={style.customEmpty} />
                )}
            </div>
        </Spin>
    );
}

export default List;
